import { useTriggerAirflowTask } from "api/api-hooks/airflow-hooks";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { Button } from "primereact/button";
import React from "react";
import { I, T } from "services/lang/LanguageService";
import { ButtonType, TaskTriggerButtonProps } from "./TaskTriggerButtonTypes";

const TaskTriggerButton = (props: TaskTriggerButtonProps) => {
  const { mutate } = useTriggerAirflowTask();

  const handleTaskTrigger = () => {
    if (!props.dagId || !props.taskId) {
      easasAlert({
        severity: "warn",
        detail: T("alert.failed-to-trigger-task"),
      });
      return;
    }

    mutate({ dagId: props.dagId, taskId: props.taskId });
  };

  if (!props.dagId || !props.taskId) {
    return (
      <i
        className="pi pi-exclamation-triangle text-orange-500"
        data-tooltip-id="dween-global-tooltip"
        data-tooltip-content={T("alert.missing-dag-or-task-id")}
        style={{ fontSize: "1.2rem" }}
      />
    );
  }

  const icon = props.buttonType !== ButtonType.LABEL_ONLY && props.icon ? props.icon : undefined;
  const label = props.buttonType !== ButtonType.ICON_ONLY && props.label ? I(props.label) : undefined;
  const tooltip = props.useTooltip && props.tooltip ? props.tooltip : undefined;

  return (
    <Button
      label={label}
      icon={icon}
      className="dashboard-editor-button icon-green"
      style={{ backgroundColor: props.theme }}
      tooltip={tooltip}
      tooltipOptions={{ position: "bottom" }}
      onClick={handleTaskTrigger}
    />
  );
};

export default TaskTriggerButton;
